import React, { useState, useEffect } from 'react';
import logo from '../assets/LOGO BLACK.png';
import logoWhite from '../assets/LOGO WHITE.png';
import './common.css';
import icon2 from '../assets/UserMultiple.svg';
import HeaderImg from '../assets/NewHome/headerimg.svg'
import { useNavigate } from 'react-router-dom';
import { FileRichtext } from 'react-bootstrap-icons';
import { trackCtaClicked } from '../utils/mixpanelClient';

const Header = ({ onOpenSignUpModal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const navigate = useNavigate();

  const handleNavigationClick = (e) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    if(e.target.textContent === 'Home') {
      navigate('/');
      window.scrollTo(0,0);
      setIsAtBottom(false);
    } else if(e.target.textContent === 'Blog') {
      // if (window.location.pathname === '/' || window.location.pathname === '') {
      //   // Already on homepage, scroll to bottom (200px up on mobile)
      //   const isMobile = window.innerWidth < 1024; // lg breakpoint
      //   const documentHeight = document.documentElement.scrollHeight;
      //   const windowHeight = window.innerHeight;
      //   const scrollTop = isMobile
      //     ? documentHeight - windowHeight - 300 // 200px up from bottom on mobile
      //     : documentHeight; // Full bottom on desktop
        
      //   window.scrollTo({
      //     top: scrollTop,
      //     behavior: 'auto'
      //   });
      //   // Set bottom state after scrolling
      //   setTimeout(() => {
      //     setIsAtBottom(true);
      //   }, 50);
      // } else {
      //   // Navigate to homepage first, store scroll intent in sessionStorage
      //   sessionStorage.setItem('scrollToBottom', 'true');
      //   navigate('/');
      // }
      window.location.href = '/blog';
      window.scrollTo(0,0);
    } else if(e.target.textContent === 'Pricing') {
      navigate('/pricing');
    }
  };

  // Handle scroll event for mobile header background and bottom detection
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50); // Change background after 50px scroll
      
      // Check if at bottom of page (within 100px threshold)
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isBottom = scrollTop + windowHeight >= documentHeight - 100;
      
      setIsAtBottom(isBottom);
    };

    window.addEventListener('scroll', handleScroll);
    // Check initial scroll position
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle scroll to bottom after navigation
  useEffect(() => {
    if (sessionStorage.getItem('scrollToBottom') === 'true') {
      sessionStorage.removeItem('scrollToBottom');
      setTimeout(() => {
        // Scroll to bottom (200px up on mobile)
        const isMobile = window.innerWidth < 1024; // lg breakpoint
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;
        const scrollTop = isMobile 
          ? documentHeight - windowHeight - 200 // 200px up from bottom on mobile
          : documentHeight; // Full bottom on desktop
        
        window.scrollTo({
          top: scrollTop,
          behavior: 'auto'
        });
        // Set bottom state after scrolling
        setIsAtBottom(true);
      }, 100); // Small delay to ensure page is loaded
    }
  }, []);
 
  // Determine active page based on current pathname and scroll position
  const currentPath = window.location.pathname.toLowerCase();
  const isCategoryPage = currentPath.includes('/category');
  const isPricingPage = currentPath === '/pricing' || currentPath.includes('pricing') || currentPath.includes('blog');
  const isOnHomepage = (currentPath === '/' || currentPath === '') && !isCategoryPage;
  const isHomeActive = isOnHomepage && !isAtBottom;
  const isAboutActive = isOnHomepage && isAtBottom;
  const isPricingActive = isPricingPage;

  return (
    <>
      {/* Scoped Inter font for Header only */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');
        .header-inter-font { font-family: 'Inter', sans-serif !important; }

        /* Diagonal swipe button inspired by .btn-1 SCSS */
        .demo-diagonal-btn {
          position: relative;
          overflow: hidden;
          isolation: isolate;
        }

        .demo-diagonal-btn > * {
          position: relative;
          z-index: 2;
        }

        .demo-diagonal-btn::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: -3rem; /* width of the triangle tip */
          border-right: 3rem solid transparent;
          border-bottom: 4rem solid rgba(15, 23, 42, 0.95); /* dark overlay */
          transform: translateX(-100%);
          transition: transform 0.4s ease;
          z-index: 1;
        }

        .demo-diagonal-btn:hover::before {
          transform: translateX(0);
        }

        /* Navigation link hover and active effects */
        .nav-link {
          position: relative;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .nav-link:hover {
          color: #0055FF !important;
          transform: translateY(-1px);
        }

        .nav-link:active {
          color: #0055FF !important;
          transform: translateY(0);
          transition: transform 0.1s ease;
        }

        .nav-link.active {
          color: #0055FF !important;
        }

        /* Icon color change on hover and click */
        .nav-link:hover svg path,
        .nav-link:active svg path {
          fill: #0055FF !important;
          transition: fill 0.3s ease;
        }

        .nav-link:hover svg,
        .nav-link:hover img {
          transform: scale(1.1);
          transition: transform 0.3s ease;
        }

        .nav-link:hover img {
          opacity: 1 !important;
          filter: brightness(0) saturate(100%) invert(27%) sepia(100%) saturate(7500%) hue-rotate(220deg) brightness(100%) contrast(100%);
        }

        .nav-link:active img {
          filter: brightness(0) saturate(100%) invert(27%) sepia(100%) saturate(7500%) hue-rotate(220deg) brightness(100%) contrast(100%);
        }

        .nav-link.active svg path {
          fill: #0055FF !important;
          transition: fill 0.3s ease;
        }

        /* Mobile nav link effects */
        .mobile-nav-link {
          transition: all 0.3s ease;
          padding: 8px 12px;
          border-radius: 6px;
          cursor: pointer;
        }

        .mobile-nav-link:hover {
          transform: translateX(4px);
          color: #0055FF !important;
        }

        .mobile-nav-link:hover svg {
          transform: scale(1.1) translateX(2px);
        }

        .mobile-nav-link:hover svg path {
          stroke: #0055FF !important;
          fill: #0055FF !important;
        }

        .mobile-nav-link:active {
          transform: translateX(2px);
          color: #0055FF !important;
        }

        .mobile-nav-link:active svg path {
          stroke: #0055FF !important;
          fill: #0055FF !important;
        }

        .mobile-nav-link.active {
          color: #0055FF !important;
        }

        .mobile-nav-link.active svg path {
          stroke: #0055FF !important;
          fill: #0055FF !important;
        }

        /* White top padding only - Desktop only */
        @media (min-width: 1024px) {
          .white-top-padding {
            background: linear-gradient(to bottom, white 1.5rem, transparent 0.75rem);
          }
        }
      `}</style>
      <header 
        style={{
          fontFamily: 'Inter, sans-serif !important',
          position: 'fixed',
          top: '-5px',
          left: 0,
          right: 0,
          width: '100%'
        }}
        className={`header-inter-font curvy-header px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 w-full z-[999] transition-all duration-300  white-top-padding py-3 ${
          isCategoryPage || isPricingPage
            ? 'bg-white'
            : isScrolled || isMenuOpen
              ? 'max-sm:bg-white'
              : 'bg-transparent'
        }`}
      >
        {/* Header Background SVG - Hidden on mobile */}
        <div className="hidden lg:block absolute inset-0 w-full h-full z-0 pointer-events-none overflow-hidden">
          <img 
            src={HeaderImg} 
            alt="" 
            className="w-full h-full"
            style={{ 
              objectFit: 'contain',
              objectPosition: 'top top'
            }}
          />
        </div>
        
        <div className="mx-auto max-w-7xl lg:max-w-[1200px] xl:max-w-[1300px] relative z-10 h-full flex items-center">
          <div className="grid grid-cols-12 gap-3 sm:gap-4 md:gap-5 lg:gap-6 items-center w-full">
            {/* Logo Section - 3 columns (Left) */}
            <div className="col-span-6 gap-8 sm:gap-10 md:gap-12 lg:gap-14 xl:gap-6 flex items-center">
              {/* White logo on homepage until scroll; force black on category */}
              <img 
                onClick={()=>{navigate('/')}} 
                src={isCategoryPage || isPricingPage ? logo : (isScrolled || isMenuOpen ? logo : logoWhite)} 
                alt="Zoi" 
                className={`lg:hidden cursor-pointer ${
                  (isScrolled || isMenuOpen || isCategoryPage || isPricingPage)
                    ? 'max-sm:h-[2.2rem] max-sm:w-auto h-6 sm:h-7 md:h-8'
                    : 'max-sm:h-10 max-sm:w-auto h-6 sm:h-7 md:h-8'
                }`} 
              />
              <img onClick={()=>{navigate('/')}} alt="Zoi" src={logo} className="hidden lg:block cursor-pointer h-9 xl:h-8" />
              <div className="hidden rounded-t-[50px] lg:flex items-center justify-start space-x-4 lg:space-x-5 xl:space-x-6 pl-3 lg:pl-4 relative">
              <span onClick={handleNavigationClick} className={`nav-link flex items-center gap-1 text-gray-600 text-[10px] md:text-[11px] lg:text-xs xl:text-sm ${isHomeActive ? 'active' : ''}`}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 transition-transform duration-300"
                >
                  <rect width="14" height="14" fill="white" fillOpacity="0.01" />
                  <path
                    d="M10.3827 1.38359C10.2717 1.29702 10.1351 1.25 9.99434 1.25C9.85362 1.25 9.71694 1.29702 9.606 1.38359L0.625 8.38709L1.40169 9.3694L2.5 8.51303V16.25C2.50068 16.5813 2.63259 16.8988 2.86686 17.1331C3.10114 17.3674 3.41869 17.4993 3.75 17.5H16.25C16.5813 17.4994 16.8989 17.3675 17.1332 17.1332C17.3675 16.8989 17.4994 16.5813 17.5 16.25V8.51871L18.5983 9.37496L19.375 8.39259L10.3827 1.38359ZM11.25 16.25H8.75V11.25H11.25V16.25ZM12.5 16.25V11.25C12.4996 10.9186 12.3678 10.6008 12.1335 10.3665C11.8991 10.1322 11.5814 10.0003 11.25 9.99996H8.75C8.41858 10.0003 8.10083 10.1321 7.86648 10.3664C7.63213 10.6008 7.50033 10.9185 7.5 11.25V16.25H3.75V7.5384L10 2.66965L16.25 7.54496V16.25H12.5Z"
                    fill={isHomeActive ? "#0055FF" : "#161616"}
                    fillOpacity="0.8"
                  />
                </svg>
                Home
              </span>
              <span onClick={handleNavigationClick} className={`nav-link flex items-center gap-1 text-gray-600 text-[10px] md:text-[11px] lg:text-xs xl:text-sm ${isAboutActive ? 'active' : ''}`}>
                <FileRichtext className={`w-3.5 h-3.5 transition-transform duration-300 ${isAboutActive ? 'opacity-100' : 'opacity-100'}`} style={isAboutActive ? { filter: 'brightness(0) saturate(100%) invert(27%) sepia(100%) saturate(7500%) hue-rotate(220deg) brightness(100%) contrast(100%)' } : {}} />
                Blog
              </span>
              <span onClick={handleNavigationClick} className={`nav-link flex items-center gap-1 text-gray-600 text-[10px] md:text-[11px] lg:text-xs xl:text-sm my-auto ${isPricingActive ? 'active' : ''}`}>
                <svg width="14" height="14" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
                  <rect width="20" height="20" transform="translate(0.5)" fill="white" fillOpacity="0.01"/>
                  <path d="M19.25 13.75H1.75V15H19.25V13.75Z" fill={isPricingActive ? "#0055FF" : "#161616"}/>
                  <path d="M19.25 16.25H1.75V17.5H19.25V16.25Z" fill={isPricingActive ? "#0055FF" : "#161616"}/>
                  <path d="M15.5 6.25C15.2528 6.25 15.0111 6.32331 14.8055 6.46066C14.6 6.59801 14.4398 6.79324 14.3451 7.02165C14.2505 7.25005 14.2258 7.50139 14.274 7.74386C14.3222 7.98634 14.4413 8.20907 14.6161 8.38388C14.7909 8.5587 15.0137 8.67775 15.2561 8.72598C15.4986 8.77421 15.7499 8.74946 15.9784 8.65485C16.2068 8.56024 16.402 8.40002 16.5393 8.19446C16.6767 7.9889 16.75 7.74723 16.75 7.5C16.75 7.16848 16.6183 6.85054 16.3839 6.61612C16.1495 6.3817 15.8315 6.25 15.5 6.25Z" fill={isPricingActive ? "#0055FF" : "#161616"}/>
                  <path d="M10.5 10C10.0055 10 9.5222 9.85338 9.11107 9.57867C8.69995 9.30397 8.37952 8.91352 8.1903 8.45671C8.00108 7.99989 7.95157 7.49723 8.04804 7.01227C8.1445 6.52732 8.3826 6.08186 8.73223 5.73223C9.08186 5.3826 9.52732 5.1445 10.0123 5.04804C10.4972 4.95157 10.9999 5.00108 11.4567 5.1903C11.9135 5.37952 12.304 5.69995 12.5787 6.11107C12.8534 6.5222 13 7.00555 13 7.5C12.9993 8.16281 12.7356 8.79826 12.2669 9.26694C11.7983 9.73562 11.1628 9.99926 10.5 10ZM10.5 6.25C10.2528 6.25 10.0111 6.32331 9.80554 6.46066C9.59998 6.59801 9.43976 6.79324 9.34515 7.02165C9.25054 7.25005 9.22579 7.50139 9.27402 7.74386C9.32225 7.98634 9.4413 8.20907 9.61612 8.38388C9.79093 8.5587 10.0137 8.67775 10.2561 8.72598C10.4986 8.77421 10.7499 8.74946 10.9784 8.65485C11.2068 8.56024 11.402 8.40002 11.5393 8.19446C11.6767 7.9889 11.75 7.74723 11.75 7.5C11.7497 7.16858 11.6179 6.85083 11.3835 6.61648C11.1492 6.38213 10.8314 6.25033 10.5 6.25Z" fill={isPricingActive ? "#0055FF" : "#161616"}/>
                  <path d="M5.5 6.25C5.25277 6.25 5.0111 6.32331 4.80554 6.46066C4.59998 6.59801 4.43976 6.79324 4.34515 7.02165C4.25054 7.25005 4.22579 7.50139 4.27402 7.74386C4.32225 7.98634 4.4413 8.20907 4.61612 8.38388C4.79093 8.5587 5.01366 8.67775 5.25614 8.72598C5.49861 8.77421 5.74995 8.74946 5.97835 8.65485C6.20676 8.56024 6.40199 8.40002 6.53934 8.19446C6.67669 7.9889 6.75 7.74723 6.75 7.5C6.75 7.16848 6.6183 6.85054 6.38388 6.61612C6.14946 6.3817 5.83152 6.25 5.5 6.25Z" fill={isPricingActive ? "#0055FF" : "#161616"}/>
                  <path d="M18 12.5H3C2.66874 12.4992 2.35128 12.3672 2.11705 12.133C1.88281 11.8987 1.75084 11.5813 1.75 11.25V3.75C1.75084 3.41874 1.88281 3.10128 2.11705 2.86705C2.35128 2.63281 2.66874 2.50084 3 2.5H18C18.3313 2.50084 18.6487 2.63281 18.883 2.86705C19.1172 3.10128 19.2492 3.41874 19.25 3.75V11.25C19.2496 11.5814 19.1177 11.8991 18.8834 12.1334C18.6491 12.3677 18.3314 12.4996 18 12.5ZM18 3.75H3V11.25H18V3.75Z" fill={isPricingActive ? "#0055FF" : "#161616"}/>
                </svg>
                Pricing
              </span>
            </div>
            </div>            
            
            <div className="col-span-3 hidden lg:block"></div>

            {/* CTA Button - 3 columns (Right side) */}
            <div className="col-span-3 max-sm:col-span-6 gap-5 flex justify-end items-center lg:justify-end lg:items-center">
               <button 
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open('https://app.thewhiteowl.ai/', '_blank');
                }}
                onTouchStart={(e) => {
                  e.stopPropagation();
                }}
                className="items-center justify-center gap-3 max-sm:hidden rounded-full py-2.5 text-[10px] sm:text-sm md:text-sm lg:text-sm xl:text-sm font-medium text-gray-600 touch-manipulation"
                style={{ WebkitTapHighlightColor: 'transparent' }}
              >
                <span className="font-medium">Login</span>
              </button>
              {/* Book a demo button - Mobile only */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  trackCtaClicked('Book a demo', { position: 'header' });
                  window.open('https://calendly.com/thewhiteowlai/quickcall', '_blank');
                }}
                onTouchStart={(e) => {
                  e.stopPropagation();
                }}
                className={`lg:hidden items-center justify-center gap-2 rounded-full px-4 py-2 text-xs sm:text-sm font-medium touch-manipulation transition-all ${
                  isScrolled || isMenuOpen || isCategoryPage || isPricingPage
                    ? 'bg-gradient-to-r from-purple-500 to-purple-700 text-white hover:from-purple-600 hover:to-purple-800'
                    : 'border border-white text-white bg-transparent hover:bg-white/10'
                }`}
                style={{ WebkitTapHighlightColor: 'transparent' }}
              >
                <span className="font-medium">Book a demo</span>
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  trackCtaClicked('Sign up', { position: 'header' });
                  onOpenSignUpModal?.();
                }}
                className="hidden cursor-pointer w-fit lg:flex items-center justify-end gap-2 lg:gap-2.5 xl:gap-3 bg-gradient-to-r from-purple-500 to-purple-700 text-white px-3 lg:px-4 xl:px-5 py-1.5 lg:py-2 xl:py-2.5 rounded-full transition-colors text-[10px] lg:text-xs xl:text-sm font-medium demo-diagonal-btn"
              >
                <span>Sign up</span>
                <svg className="w-3 h-3 lg:w-4 lg:h-4 xl:w-5 xl:h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
              
              {/* Mobile Menu Button - Show on mobile and tablet, hide on lg, right aligned */}
              <button 
                className={`lg:hidden ${isCategoryPage || isPricingPage || isScrolled || isMenuOpen ? 'text-black' : 'text-white'}`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <svg className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white py-3 sm:py-4 md:py-5 px-4 sm:px-6 md:px-8 shadow-lg z-20">
            <nav className="flex flex-col space-y-3 sm:space-y-4 md:space-y-5">
              <span onClick={handleNavigationClick} className={`mobile-nav-link justify-end flex items-center gap-2 sm:gap-2.5 md:gap-3 ${isHomeActive ? 'active text-[#0055FF]' : 'text-black'} text-sm sm:text-base md:text-lg`}>
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Home
              </span>
              <span onClick={handleNavigationClick} className={`mobile-nav-link justify-end flex items-center gap-2 sm:gap-2.5 md:gap-3 ${isAboutActive ? 'active text-[#0055FF]' : 'text-black'} text-sm sm:text-base md:text-lg`}>
                <FileRichtext className={`w-3.5 h-3.5 transition-transform duration-300 ${isAboutActive ? 'opacity-100' : 'opacity-80'}`} style={isAboutActive ? { filter: 'brightness(0) saturate(100%) invert(27%) sepia(100%) saturate(7500%) hue-rotate(220deg) brightness(100%) contrast(100%)' } : {}} />
                Blog
              </span>
              <span onClick={handleNavigationClick} className={`mobile-nav-link justify-end flex items-center gap-2 sm:gap-2.5 md:gap-3 ${isPricingActive ? 'active text-[#0055FF]' : 'text-black'} text-sm sm:text-base md:text-lg`}>
                <svg width="21" height="20" viewBox="0 0 21 20" fill="#000000" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6">
                  <rect width="20" height="20" transform="translate(0.5)" fill="#000000" fillOpacity="0.01"/>
                  <path d="M19.25 13.75H1.75V15H19.25V13.75Z" fill={isPricingActive ? "#0055FF" : "#000000"}/>
                  <path d="M19.25 16.25H1.75V17.5H19.25V16.25Z" fill={isPricingActive ? "#0055FF" : "#000000"}/>
                  <path d="M15.5 6.25C15.2528 6.25 15.0111 6.32331 14.8055 6.46066C14.6 6.59801 14.4398 6.79324 14.3451 7.02165C14.2505 7.25005 14.2258 7.50139 14.274 7.74386C14.3222 7.98634 14.4413 8.20907 14.6161 8.38388C14.7909 8.5587 15.0137 8.67775 15.2561 8.72598C15.4986 8.77421 15.7499 8.74946 15.9784 8.65485C16.2068 8.56024 16.402 8.40002 16.5393 8.19446C16.6767 7.9889 16.75 7.74723 16.75 7.5C16.75 7.16848 16.6183 6.85054 16.3839 6.61612C16.1495 6.3817 15.8315 6.25 15.5 6.25Z" fill={isPricingActive ? "#0055FF" : "#000000"}/>
                  <path d="M10.5 10C10.0055 10 9.5222 9.85338 9.11107 9.57867C8.69995 9.30397 8.37952 8.91352 8.1903 8.45671C8.00108 7.99989 7.95157 7.49723 8.04804 7.01227C8.1445 6.52732 8.3826 6.08186 8.73223 5.73223C9.08186 5.3826 9.52732 5.1445 10.0123 5.04804C10.4972 4.95157 10.9999 5.00108 11.4567 5.1903C11.9135 5.37952 12.304 5.69995 12.5787 6.11107C12.8534 6.5222 13 7.00555 13 7.5C12.9993 8.16281 12.7356 8.79826 12.2669 9.26694C11.7983 9.73562 11.1628 9.99926 10.5 10ZM10.5 6.25C10.2528 6.25 10.0111 6.32331 9.80554 6.46066C9.59998 6.59801 9.43976 6.79324 9.34515 7.02165C9.25054 7.25005 9.22579 7.50139 9.27402 7.74386C9.32225 7.98634 9.4413 8.20907 9.61612 8.38388C9.79093 8.5587 10.0137 8.67775 10.2561 8.72598C10.4986 8.77421 10.7499 8.74946 10.9784 8.65485C11.2068 8.56024 11.402 8.40002 11.5393 8.19446C11.6767 7.9889 11.75 7.74723 11.75 7.5C11.7497 7.16858 11.6179 6.85083 11.3835 6.61648C11.1492 6.38213 10.8314 6.25033 10.5 6.25Z" fill={isPricingActive ? "#0055FF" : "#000000"}/>
                  <path d="M5.5 6.25C5.25277 6.25 5.0111 6.32331 4.80554 6.46066C4.59998 6.59801 4.43976 6.79324 4.34515 7.02165C4.25054 7.25005 4.22579 7.50139 4.27402 7.74386C4.32225 7.98634 4.4413 8.20907 4.61612 8.38388C4.79093 8.5587 5.01366 8.67775 5.25614 8.72598C5.49861 8.77421 5.74995 8.74946 5.97835 8.65485C6.20676 8.56024 6.40199 8.40002 6.53934 8.19446C6.67669 7.9889 6.75 7.74723 6.75 7.5C6.75 7.16848 6.6183 6.85054 6.38388 6.61612C6.14946 6.3817 5.83152 6.25 5.5 6.25Z" fill={isPricingActive ? "#0055FF" : "#000000"}/>
                  <path d="M18 12.5H3C2.66874 12.4992 2.35128 12.3672 2.11705 12.133C1.88281 11.8987 1.75084 11.5813 1.75 11.25V3.75C1.75084 3.41874 1.88281 3.10128 2.11705 2.86705C2.35128 2.63281 2.66874 2.50084 3 2.5H18C18.3313 2.50084 18.6487 2.63281 18.883 2.86705C19.1172 3.10128 19.2492 3.41874 19.25 3.75V11.25C19.2496 11.5814 19.1177 11.8991 18.8834 12.1334C18.6491 12.3677 18.3314 12.4996 18 12.5ZM18 3.75H3V11.25H18V3.75Z" fill={isPricingActive ? "#0055FF" : "#000000"}/>
                </svg>
                Pricing
              </span>
              <span 
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open('https://app.thewhiteowl.ai/', '_blank');
                  setIsMenuOpen(false);
                }}
                className="mobile-nav-link justify-end flex items-center gap-2 sm:gap-2.5 md:gap-3 text-black text-sm sm:text-base md:text-lg border-t border-gray-200 pt-3 sm:pt-4 md:pt-5 mt-3 sm:mt-4 md:mt-5"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Login
              </span>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header; 